import { GrowthBook } from '@growthbook/growthbook';
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins';
import { trackEvent } from '../analytics';

export const growthbook = new GrowthBook({
  apiHost: 'https://growth-book-api.gfmunit6.co.uk',
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: true,
  trackingCallback: (experiment, result) => {
    trackEvent('experiment_viewed', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
  plugins: [autoAttributesPlugin()],
});
growthbook.init({
  streaming: true,
});
